import React from 'react';
import { FaEnvelope, FaFacebookF, FaPhoneAlt, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { BiMap } from 'react-icons/bi';
import { Link } from 'react-router-dom';

const Footer = () => {
   return (
      <>
         <footer>
            <div className="footer__area grey-bg pt-100">
               <div className="footer__top pb-45">
                  <div className="container">
                     <div className="row">
                        <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 d-none d-md-inline-block">
                           <div className="footer__widget mb-45">
                              <div className="footer__widget-title">
                                 <h4>Company</h4>
                              </div>
                              <div className="footer__widget-content">
                                 <div className="footer__links">
                                    <ul>
                                       <li><Link to="/home">Home</Link></li>
                                       <li><Link to="/about">About Us</Link></li>
                                       <li><Link to="/contact">Contact Us</Link></li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div className="col-xl-2 offset-xl-1 col-lg-2 offset-lg-1 col-md-4 col-sm-6  d-none d-md-inline-block">
                           <div className="footer__widget mb-45 wow fadeInUp" data-wow-delay=".4s">
                              <div className="footer__widget-title">
                                 <h4>Company</h4>
                              </div>
                              <div className="footer__widget-content">
                                 <div className="footer__links">
                                    <ul>
                                       <li><Link to="/services">Services</Link></li>
                                       <li><Link to="/portfolio">Equipment</Link></li>
                                       <li><Link to="/careers">Careers</Link></li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div className="col-xl-2 offset-xl-1 col-lg-2 offset-lg-1 col-md-4 col-sm-6  d-none d-md-inline-block">
                           <div className="footer__widget mb-45">
                              <div className="footer__widget-title">
                                 <h4>Services</h4>
                              </div>
                              <div className="footer__widget-content">
                                 <div className="footer__links">
                                    <ul>
                                       <li><Link to="/services">Team Expedited</Link></li>
                                       <li><Link to="/services">Full Truck Load</Link></li>
                                       <li><Link to="/services">24/7 Support</Link></li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div className="col-xl-3 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 col-sm-6">
                           <div className="footer__widget mb-45">
                              <div className="footer__widget-title">
                                 <h4>Information</h4>
                              </div>
                              <div className="footer__widget-content">
                                 <div className="footer__info">
                                    <ul>
                                       <li>
                                          <div className="icon">
                                             <i > <BiMap /> </i>
                                          </div>
                                          <div className="text">
                                             <span>5051 FOREST DR STE A, NEW ALBANY, OH 43054</span>
                                          </div>
                                       </li>
                                       <li>
                                          <div className="icon theme-color ">
                                             <i > <FaEnvelope/> </i>
                                          </div>
                                          <div className="text theme-color ">
                                             <span><a href="mailto:dispatch@jrdtrans.com">dispatch@jrdtrans.com</a></span>
                                          </div>
                                       </li>
                                       <li>
                                          <div className="icon theme-color">
                                             <i ><FaPhoneAlt/> </i>
                                          </div>
                                          <div className="text theme-color">
                                             <span><a href="tel:+1 614-534-0560">+1 614-534-0560</a></span>
                                          </div>
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="footer__copyright">
                  <div className="container">
                     <div className="row align-items-center">
                        <div className="col-xl-8 col-lg-8 col-md-8">
                           <div className="footer__copyright-text">
                              <p>Copyright © 2024 JRD Transportation All Rights Reserved | Powered by <a href="https://nikba.com" rel="noreferrer" target="_blank">Nikba Creative Studio</a></p>
                           </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4">
                           <div className="footer__social theme-social f-right">
                              <ul>
                                 <li>
                                    <a href="https://www.facebook.com/JRD.Transportation" target="_blank" rel="noreferrer">
                                       <i ><FaFacebookF/></i>
                                       <i ><FaFacebookF/></i>
                                    </a>
                                 </li>
                                 <li>
                                    <a href="https://www.instagram.com/jrdtransport/" target="_blank" rel="noreferrer">
                                       <i ><FaInstagram/> </i>
                                       <i ><FaInstagram/> </i>
                                    </a>
                                 </li>
                                 <li>
                                    <a href="https://www.linkedin.com/company/83481750/" target="_blank" rel="noreferrer">
                                       <i ><FaLinkedinIn/> </i>
                                       <i ><FaLinkedinIn/> </i>
                                    </a>
                                 </li>
                              </ul>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </footer>
      </>
   );
};

export default Footer;